import { useQuery } from '@tanstack/react-query';
import {
  getDiscourseAuth,
  getDiscourseExternalUser,
} from '@wellstone-solutions/api/v2';

const fetchDiscourseUser = async () => {
  const response = await getDiscourseExternalUser();

  return response.data;
};

const fetchDiscourseAuth = async (
  sso: string,
  sig: string,
  userName: string
) => {
  return await getDiscourseAuth({
    sso,
    sig,
    userName,
  });
};

const useGetDiscourseUser = (userId: string | undefined) => {
  return useQuery({
    queryKey: ['discourse-user', userId],
    queryFn: () => fetchDiscourseUser(),
    enabled: !!userId,
  });
};

export { useGetDiscourseUser, fetchDiscourseUser, fetchDiscourseAuth };
